module.exports = __webpack_public_path__ + "img/small_flow.95037abb.png";